import {
  Avatar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import {
  DELETE_INVITE,
  FETCH_TEAM_ASSOCIATES_LOADING,
} from "../../../containers/actions/types";
import {
  ChevronLeft,
  ChevronRight,
  Clear,
  Refresh,
  Search,
} from "@material-ui/icons";
import { deleteInvite } from "../../../containers/actions/common/teamMemberAction";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useDispatch, useSelector } from "react-redux";
import BackDropLoading from "../models/BackDrop";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ViewDetails from "./invitationView/ViewDetails";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  searchField: {
    marginBottom: theme.spacing(2),
  },
  deleteLogo: {
    border: "1px solid red",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    transition: "color 0.3s ease-in-out",
    color: "red",
    "&:hover": {
      color: "darkred",
      border: "1px solid darkred",
    },
  },
  multipleLogo: {
    border: "1px solid #7d7c7c",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    //color: '#fff',
    backgroundColor: "rgba(0, 0, 0, 0.24)",
  },
  hr: {
    border: "1px solid grey",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    width: "100%",
    borderBottom: "thick",
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  drawerPaper: {
    width: "30vw", // Set the drawer width here
  },
}));

const InvitationSent = ({
  teamMembersList,
  teamMembersListLoading,
  fetchDepartmentsList,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [deleteRole, setDeleteRole] = useState(false);
  const [search, setSearch] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [profileData, setProfileData] = useState({ role: "All" });
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedSaasUserId, setSelectedSaasUserId] = useState(null);
  const [selectedTempCollabId, setSelectedTempCollabId] = useState(null);
  const [departmentID, setDepartmentID] = useState(0);
  const [paginatedData, setPaginatedData] = useState([]);
  const [collaboratorRoleID, setCollaboratorRoleID] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showPagination, setShowPagination] = useState(false);
  const [ViewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [user, setUser] = useState({});

  //Screen Access
  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data.manageTeamMembers
  );

  const featuresAccess = useSelector(
    (state) => state.pcmp.common.accessControl.featuresAccess.manageTeamMembers
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(getFeaturesAccess(screenAccess?.screenId, "manageTeamMembers"));
  }, [dispatch, screenAccess, featuresAccess]);

  const DeleteInviteData = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.deleteInvite
      ? state?.pcmp?.common?.teamMembers?.deleteInvite
      : [];
  });
  const handleDetailView = (user) => {
    setUser(user);
    setViewDetailsDrawer(true);
    // fetchDepartmentsList
  };
  useEffect(() => {
    let pendingCount =
      teamMembersList?.data?.filter((item) => item.account_status === "Pending")
        .length || 0;

    // let totalRecords = pendingCount;
    setTotalRecords(pendingCount);
    setShowPagination(pendingCount > 0);

    const pages = Math.ceil(pendingCount / rowsPerPage); // Calculate number of pages
    setTotalPages(pages);

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, pendingCount);

    // Slice the data based on pagination
    let newPaginatedData = [];
    if (
      Array.isArray(teamMembersList?.data) &&
      teamMembersList?.data.length > 0
    ) {
      const filteredData = teamMembersList?.data.filter(
        (member) => member.account_status === "Pending"
      );
      newPaginatedData = filteredData?.slice(startIndex, endIndex);
    }

    setPaginatedData(newPaginatedData);
  }, [teamMembersList, rowsPerPage, currentPage, totalPages]);

  const handleProceedDelete = () => {
    setShowDrawer(false);
    setDeleteRole(true);
    dispatch({
      type: DELETE_INVITE,
      payload: {},
    });
    if (selectedTempCollabId) {
      dispatch(
        deleteInvite({
          // saas_user_id: selectedSaasUserId ?? null,
          temp_ecosystem_collab_id: selectedTempCollabId ?? null,
        })
      );
    }
  };

  const UserAvatar = ({ profileImage, profileName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={profileImage} // Use the Base64 string here
          alt={profileName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };

  const handleDeleteRole = (tempEcosystemCollabId) => {
    setShowDrawer(true); // Close the dialog after deletion
    // setSelectedSaasUserId(saasUserId);
    setSelectedTempCollabId(tempEcosystemCollabId);
  };

  const handleConfirmDelete = () => {
    dispatch({
      type: DELETE_INVITE,
      value: {},
    });
    setDeleteRole(false);
    handleRefresh();
  };

  let Count = teamMembersList?.data?.filter(
    (item) => item.account_status === "Pending"
  ).length;

  const handleSearch = () => {
    setCurrentPage(1);
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search.trim(),
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  };

  const handleClearSearch = () => {
    setCurrentPage(1);
    setSearch("");
    // setDepartmentID(0);
    // setCollaboratorRoleID(0);
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: "all",
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
      })
    );
  };

  const handleClearFilters = () => {
    setSearch("");
    setRowsPerPage(5);
    setCurrentPage(1);
    setDepartmentID(0);
    setCollaboratorRoleID(0);
    setProfileData({ role: "All" });
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: "all",
        status: "all",
        departmentID: 0,
        collaborator_role_id: 0,
        // pageNumber: 1,
        // pageSize: 5,
      })
    );
  };

  const handleRefresh = () => {
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search,
        departmentID: departmentID,
        collaborator_role_id: collaboratorRoleID,
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); //Reset to first page
    // paginateData();
    // dispatch(
    //   fetchTeamAssociates({
    //     searchString: search,
    //     departmentID: departmentID,
    //     collaborator_role_id: collaboratorRoleID,
    //     pageNumber: currentPage,
    //     pageSize: newRowsPerPage,
    //   })
    // );
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // dispatch({
    //   type: FETCH_TEAM_ASSOCIATES_LOADING,
    //   payload: true,
    // });
    // dispatch(
    //   fetchTeamAssociates({
    //     searchString: search,
    //     departmentID: departmentID,
    //     collaborator_role_id: collaboratorRoleID,
    //     pageNumber: newPage,
    //     pageSize: rowsPerPage,
    //   })
    // );
  };

  const getRoleOptions = () => {
    let options = [];
    if (!options.some((option) => option.displayName === "All")) {
      options.push({
        displayName: "All",
        departmentID: 0,
        collaborator_role_id: 0,
      });
    }
    fetchDepartmentsList.forEach((department) => {
      department.rolesList.forEach((role) => {
        options.push({
          displayName: `${department.departmentName} - ${role.role_name}`,
          departmentID: department.departmentID,
          collaborator_role_id: role.collaborator_role_id,
        });
      });
    });
    return options;
  };
  const roleOptions = getRoleOptions();

  const handleRoleChange = (event) => {
    const selectedOption = roleOptions.find(
      (option) => option.displayName === event.target.value
    );
    const newDepartmentID = selectedOption?.departmentID || 0;
    const newCollaboratorRoleID = selectedOption?.collaborator_role_id || 0;

    setProfileData((prev) => ({
      ...prev,
      role: event.target.value,
    }));

    setDepartmentID(newDepartmentID);
    setCollaboratorRoleID(newCollaboratorRoleID);
    setCurrentPage(1); // Reset to first page when filter changes

    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        searchString: search,
        departmentID: newDepartmentID,
        collaborator_role_id: newCollaboratorRoleID,
        // pageNumber: 1,
        // pageSize: rowsPerPage,
      })
    );
  };

  return (
    <div>
      <BackDropLoading />
      <div>
        {/* <TextField
        className={classes.searchField}
        label="Search"
        variant="outlined"
        size="small"
        fullWidth
        onChange={(e) => setSearch(e.target.value)}
      /> */}

        <Box
          style={{
            border: "1px solid #bdbdbd",
            padding: "1rem",
            // borderRadius: "0.5rem",
            paddingBottom: "1rem",
            marginTop: "2rem",
          }}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
              flexDirection: "row",
            }}
          >
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  flexDirection: "column",
                  marginTop: "1.5rem",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }}>Search</Typography>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <Grid>
                    {/* <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "13rem", marginRight: "2rem" }}
                  > */}
                    <TextField
                      placeholder="Search using full name"
                      variant="outlined"
                      size="small"
                      style={{ marginRight: 16, width: "13rem" }}
                      value={search}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow alphabets and single spaces only, no multiple spaces between words
                        const regex = /^[A-Za-z ]*$/;
                        if (regex.test(value)) {
                          // Remove multiple spaces and trim leading/trailing spaces
                          const formattedValue = value.replace(/\s{2,}/g, " ");
                          setSearch(formattedValue);
                        }
                      }}
                      onBlur={(e) => {
                        const { value } = e.target;
                        // Trim leading and trailing spaces for string values
                        if (typeof value === "string" && value.trim() !== value) {
                          setSearch(value.trim());
                        }
                      }}
                      onKeyDown={(e) => {
                          const {  value } = e.target;
                          if(e.key === "Enter"){
                            setSearch(value.trim());
                            handleSearch()
                          }
                        }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            {search && (
                              <Tooltip title="Clear search" aria-label="clear">
                                <Clear
                                  fontSize="small"
                                  onClick={handleClearSearch}
                                  style={{
                                    cursor: "pointer",
                                    color: "dimgray",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* </FormControl> */}
                  </Grid>
                  <Grid>
                    <Button
                      variant="contained"
                      style={{
                        marginRight: "2rem",
                        borderRadius: "0.5rem",
                        textTransform: "none",
                        backgroundColor: "#286acf",
                        color: "#fff",
                      }}
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              {/* ////////////   */}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  flexDirection: "column",
                  marginTop: "1.5rem",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }}>
                    Department - Role
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "13rem", marginRight: "2rem" }}
                  >
                    <TextField
                      size="small"
                      select
                      variant="outlined"
                      placeholder="Choose option"
                      // className={classes.textfieldWidth}
                      onChange={handleRoleChange}
                      value={profileData.role || "all"}
                    >
                      {roleOptions.map((option) => (
                        <MenuItem
                          key={option.displayName}
                          value={option.displayName}
                        >
                          {option.displayName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid
                style={{
                  gap: "20px",
                  marginTop: "4rem",
                }}
              >
                <Typography
                  variant="caption"
                  style={{
                    fontSize: 12,
                    color: "#0000ff",
                    cursor: "pointer",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                  }}
                  className={classes.clearText}
                  onClick={handleClearFilters}
                >
                  Clear All Filter
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Grid
                item
                style={{
                  // textDecoration: 'underline',
                  // fontStyle: 'italic',
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="body2"
                  style={{ color: "gray", marginRight: "8px" }}
                >
                  {`Last synced @ ${moment(new Date()).format(
                    "HH:mm:ss; DD MMMM, YYYY"
                  )}`}
                </Typography>
                <Grid>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{
                      textDecoration: "underline",
                      fontStyle: "italic",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={handleRefresh}
                  >
                    Refresh
                    <Refresh color="primary" fontSize="small" />
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginRight: "4px",
                    whiteSpace: "nowrap",
                  }}
                >
                  PER PAGE
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <TableContainer
          component={Paper}
          style={{
            borderLeft: "1px solid #bdbdbd",
            borderRight: "1px solid #bdbdbd",
            borderBottom: "1px solid #bdbdbd",
          }}
        >
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Team Member</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Employee Number</TableCell>
                <TableCell>Department - Role</TableCell>
                <TableCell>Status</TableCell>
                {((localStorage?.roleName === "Admin" &&
                 (localStorage?.departmentId === "null" ||
               Number(localStorage?.getItem("departmentId")) === 1 )) &&
                  (featuresAccess?.viewTeamMemberDetails ||
                  featuresAccess?.deleteInvitation)) ?
                    <TableCell>Action</TableCell> : <TableCell></TableCell>
                  }
              </TableRow>
            </TableHead>
            <TableBody>
              {teamMembersListLoading === true ? (
                <TableRow style={{ height: 150 }}>
                  <TableCell colSpan={12}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              ) : Count === 0 ? ( // No records condition
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : paginatedData?.length > 0 ? (
                paginatedData
                  // ?.filter((member) => member.account_status === "Pending")
                  .map((member, index) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "0.3rem",
                        }}
                      >
                        <Grid>
                          <UserAvatar profileImage={member?.profile_pic} />
                        </Grid>
                        <Grid
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                        >
                          <Typography>{member?.full_name || "NA"}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            {member?.email_address || "NA"}
                          </Typography>
                        </Grid>
                      </TableCell>
                      <TableCell>
                        {!member?.phone_number ||
                          member?.phone_number?.trim() === "" ||
                          member?.phone_number?.toLowerCase() === "null"
                          ? "NA"
                          : (() => {
                              let phoneNumber = member.phone_number.trim();
                              
                            
                              if (phoneNumber.startsWith("+")) {
                              
                                if (phoneNumber.startsWith("+91")) {
                                  const restOfNumber = phoneNumber.substring(3).replace(/\s+/g, "");
                                  return `+91 ${restOfNumber}`;
                                }
                               
                                else if (phoneNumber.startsWith("+1")) {
                                  const restOfNumber = phoneNumber.substring(2).replace(/\s+/g, "");
                                  return `+1 ${restOfNumber}`;
                                }
                              
                                else if (phoneNumber.match(/^\+\d{2}/)) {
                                  const countryCode = phoneNumber.substring(0, 3); 
                                  const restOfNumber = phoneNumber.substring(3).replace(/\s+/g, "");
                                  return `${countryCode} ${restOfNumber}`;
                                }
                               
                                else if (phoneNumber.match(/^\+\d{3}/)) {
                                  const countryCode = phoneNumber.substring(0, 4); 
                                  const restOfNumber = phoneNumber.substring(4).replace(/\s+/g, "");
                                  return `${countryCode} ${restOfNumber}`;
                                }
                                return phoneNumber;
                              } 
                             
                              else if (phoneNumber.startsWith("91") && phoneNumber.length > 10) {
                                return `+91 ${phoneNumber.substring(2)}`;
                              } 
                              
                              else {
                                return `+91 ${phoneNumber}`;
                              }
                            })()}
                      </TableCell>
                      <TableCell>{member?.employee_number || "NA"}</TableCell>
                      <TableCell>
                        {`${member?.department_name || "NA"}-${member?.roleName || "NA"
                          }`}
                        <br />
                        <Typography variant="body2" color="textSecondary">
                          {member?.access ? `${member.access} access` : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          style={{ backgroundColor: "#616161", color: "white" }}
                        >
                          {member?.account_status || "NA"}
                        </Button>
                      </TableCell>
                      <TableCell>
                        {(localStorage?.roleName === "Admin" &&
                     (localStorage?.departmentId === "null" ||
                    Number(localStorage?.getItem("departmentId")) === 1 ))
                    //  || Number(localStorage?.departmentId) ===
                    //       member?.department_id)
                           &&
                          featuresAccess?.viewTeamMemberDetails && (
                            <VisibilityIcon
                              fontSize="small"
                              className={classes.multipleLogo}
                              onClick={() => handleDetailView(member)}
                            />
                          )}

                        {(localStorage?.roleName === "Admin" &&
                       (localStorage?.departmentId === "null" ||
                     Number(localStorage?.getItem("departmentId")) === 1 )) 
                    //  || Number(localStorage?.departmentId) ===
                    //       member?.department_id)
                           &&
                          featuresAccess?.deleteInvitation && (
                            <DeleteOutlinedIcon
                              //  onClick={handleDeleteRole}
                              onClick={() =>
                                handleDeleteRole(
                                  // member.saas_user_id,
                                  member.temp_ecosystem_collab_id
                                )
                              }
                              fontSize="small"
                              className={classes.deleteLogo}
                            // style={{ color: "red" }}
                            />
                          )}
                      </TableCell>
                    </TableRow>
                  ))
              ) : teamMembersList.status === false ? (
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell colSpan={10} align="center">
                    'Something went wrong. Please contact Schrocken support.'
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Drawer
            anchor="right"
            open={ViewDetailsDrawer}
            onClose={() => setViewDetailsDrawer(false)}
            classes={{ paper: classes.drawerPaper }}
          // hideBackdrop={true}
          >
            <ViewDetails
              user={user}
              setViewDetailsDrawer={setViewDetailsDrawer}
              handleRefresh={handleRefresh}
            />
          </Drawer>
        </TableContainer>

        {showPagination === true && (
          // teamMembersListLoading === false &&
          <Box
            style={{
              marginTop: 24,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingRight: "2rem",
            }}
          >
            <IconButton
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              <ChevronLeft />
            </IconButton>
            <Typography style={{ margin: "0 16px" }}>
              Page {currentPage} of {totalPages}
            </Typography>
            <IconButton
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              <ChevronRight />
            </IconButton>
          </Box>
        )}

        <Backdrop className={classes.backdrop} open={showDrawer}>
          <Slide direction="left" in={showDrawer} mountOnEnter unmountOnExit>
            <Box
              sx={{
                width: "20rem",
                height: "100%",
                position: "fixed",
                right: 0,
                top: 0,
                backgroundColor: "#fff",
                padding: "16px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                zIndex: 1300,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Delete department
                </Typography>
                <hr className={classes.hr} />
                <Typography variant="body1" gutterBottom>
                  <b>Warning:</b>
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    border: "2px solid red", // Red border
                    borderRadius: "4px",
                    padding: "8px",
                    fontWeight: "bold",
                    color: "red", // Red text
                    lineHeight: 1.5,
                  }}
                >
                  Invitation deletion: You are deleting the new team member
                  invitation.The invitation link will not work. You can't
                  reverse this process.{" "}
                </Typography>
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                style={{ paddingBottom: "3rem" }}
                mt={4}
              >
                <Button
                  variant="outlined"
                  onClick={() => setShowDrawer(false)}
                  style={{
                    textTransform: "none",
                    borderRadius: "8px",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  //onClick={() => handleProceedDelete(department.departmentID,department.tempID)}
                  // onClick={() => handleProceedDelete(selectedDepartment.departmentID,selectedDepartment.tempID)}
                  onClick={handleProceedDelete}
                  style={{
                    textTransform: "none",
                    borderRadius: "8px",
                    backgroundColor: "#1976D2",
                  }}
                >
                  Confirm deletion
                </Button>
              </Box>
            </Box>
          </Slide>
        </Backdrop>
      </div>
      {DeleteInviteData.status === true && (
        <Dialog open={deleteRole} maxWidth="sm" fullWidth>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.avatar} />

            <Typography variant="h6" style={{ marginTop: "10px" }}>
              Deleted invitation successfully
            </Typography>
            <Typography variant="body1" style={{ marginTop: "10px" }}>
              The invitation has been deleted successfully
            </Typography>

            <DialogActions className={classes.dialogActions}>
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: "20px",
                  textTransform: "none",
                }}
                onClick={handleConfirmDelete}
              >
                Ok
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default InvitationSent;
